import { version } from '../../../package.json';

/**
 * Application version, read from package.json so the release version only has to be bumped in one place.
 */
export const APP_VERSION: string = version;
